import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi, { IChangePasswordPayload, IChangePasswordResponse } from '~/apis/auth';

export const CHANGE_PASSWORD = 'auth/changePassword';

export const handleChangePassword = createAsyncThunk<
  IChangePasswordResponse,
  IChangePasswordPayload,
  { rejectValue: { message: string } }
>(
  CHANGE_PASSWORD,
  async (data, { rejectWithValue }) => {
    try {
      const res = await authApi.changePassword(data);
      return res.data.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error?.response?.data?.message || error?.message || 'Failed to change password',
      });
    }
  }
);